<script lang="ts">
    import {onMount} from "svelte";

    export let isDisable = false;

    $: isShowSlot = (() => {
        if (isDisable) {
            return true;
        }
        return isIntersecting;
    })();

    let intersectionObserver = null;
    let isIntersecting = false;
    let rootElement = null;

    onMount(() => {
        intersectionObserver = new IntersectionObserver((entryElements, intersectionObserver) => {
            for (let entryElement of entryElements) {
                // 表示されていない
                if (!entryElement.isIntersecting) {
                    continue;
                }

                isIntersecting = true;

                // 監視の解除
                intersectionObserver.unobserve(rootElement);
                intersectionObserver = null;
            }

        });
        intersectionObserver.observe(rootElement);
    });


</script>

{#if isShowSlot}
    <slot/>
{:else}
    <div class="intersection-observer-view" bind:this={rootElement}></div>
{/if}


